import * as tslib_1 from "tslib";
import { env } from '@ivy/fts/envInfo/envInfo';
import { Component, Vue } from 'vue-property-decorator';
import GoodsInfo from './comps/goodsInfo.vue';
import CartFooter from './comps/cartFooter.vue';
import GiftsPop from './comps/giftsPop.vue';
import DiscountPop from './comps/discountPop.vue';
import CartLevel from './comps/cartLevel.vue';
import TitleBar from '../goods-new/comps/TitleBar.vue';
import * as goodsApi from '@/api/goods';
import { uploadEvent } from '@/api/goods/statistics';
let Cart = class Cart extends Vue {
    constructor() {
        super(...arguments);
        this.navbarHeight = 0;
        this.cartData = {};
        this.isGiftsPopShow = false;
        this.giftsInfo = [];
        this.baseNum = 1;
        this.isDiscountPopShow = false;
        this.isCartLevelShow = false;
        this.cartLevelInfo = {};
        this.allLoaded = false;
        this.limit = 200; // weex 跳的部分机型触发不了加载 暂时不限制了
        this.isExposured = false;
        this.isVip = false;
        this.loginfo = {};
    }
    get isApp() {
        return env.type === 'ivydad' || env.type === 'web';
    }
    get uploadEvent() {
        return uploadEvent;
    }
    // 购物车商品列表
    get skuList() {
        if (this.cartData &&
            this.cartData.product_info &&
            this.cartData.product_info.length) {
            return [
                ...this.cartData.product_info.filter(el => el.is_sale && el.stock_status && el.sku_status),
                ...this.cartData.product_info.filter(el => !el.is_sale || !el.stock_status || !el.sku_status),
            ].splice(0, this.limit);
        }
        else {
            return [];
        }
    }
    async created() {
        this.getUserIsVip();
        let isAppTab = this.$route.query.isAppTab || '';
        await uploadEvent.init();
        // 电商埋点-购物车曝光
        uploadEvent[+isAppTab ? 'sendRecord' : 'sendPV']('Exposure_Page', '', { PageName: '购物车', FromPage: 1 }, [
            ['p1', 'PageName'],
            ['p2', 'FromPage'],
        ]).then(() => {
            uploadEvent.sendRecord('Exposure_ShoppingCart', '', { FromPage: 1 }, [
                ['p1', 'FromPage'],
            ]);
            this.isExposured = true;
        });
        await env.init();
        const isLogin = await env.getIsLogin();
        if (!isLogin) {
            return await env.login();
        }
        let { data: { data: cartData }, } = await goodsApi.getCartData();
        this.updateData(cartData);
    }
    async mounted() {
        // 获取登陆信息判断是不是会员
        this.navbarHeight = (await env.getNavbarHeight()) || 25;
        this.initDisplayEvent();
    }
    //获取用户登陆信息
    async getUserIsVip() {
        await env.init();
        if (!(await env.getIsLogin())) {
            return await env.login();
        }
        let loginfo = await env.getInfo();
        this.loginfo = loginfo;
        if (this.isApp) {
            if (loginfo.userInfo && loginfo.userInfo.isVip == '1')
                this.isVip = true;
        }
        else {
            if (loginfo.logined && loginfo.logined.vip)
                this.isVip = true;
        }
    }
    // 展示赠品弹窗
    showGiftsPop(giftsInfo, baseNum) {
        if (!giftsInfo || !giftsInfo.length)
            return;
        this.giftsInfo = giftsInfo;
        this.baseNum = baseNum;
        this.isGiftsPopShow = true;
    }
    // 展示优惠明细弹窗
    showDiscountPop() {
        this.isDiscountPopShow = true;
    }
    // 显示选择规格弹窗
    showChangeAttr(info) {
        if (info && info.spu_id && info.sku_id) {
            this.cartLevelInfo = info;
            this.isCartLevelShow = true;
        }
    }
    // 修改商品规格
    async changeAttrs(level) {
        const { data: { data: cartData }, } = await goodsApi.saveCart({
            type: 7,
            replace_sku_id: level.id,
            sku_id: this.cartLevelInfo.sku_id,
            num: level._num,
        });
        this.updateData(cartData);
        this.$forceUpdate();
    }
    // 刷新页面
    async loadTop() {
        let { data: { data: cartData }, } = await goodsApi.getCartData();
        this.updateData(cartData);
        const loadmore = this.$refs.loadmore;
        loadmore.onTopLoaded();
    }
    // 更新购物车数据
    async updateData(cartData) {
        this.cartData = cartData;
        this.$title(`购物车(${cartData.total_sku || '0'})`);
    }
    // 加载更多
    async loadMore() {
        if (this.cartData &&
            this.cartData.product_info &&
            this.cartData.product_info.length > this.limit) {
            this.limit += 5;
        }
    }
    // app 隐藏后显示上报曝光
    initDisplayEvent() {
        if (env.type === 'ivydad') {
            document.addEventListener('visibilitychange', this.visibilityChange);
        }
    }
    visibilityChange() {
        let isHidden = document.hidden;
        let isAppTab = this.$route.query.isAppTab || '';
        if (!isHidden && this.isExposured) {
            uploadEvent[+isAppTab ? 'sendRecord' : 'sendPV']('Exposure_Page', '', { PageName: '购物车', FromPage: 1 }, [
                ['p1', 'PageName'],
                ['p2', 'FromPage'],
            ]);
        }
    }
    destroyed() {
        if (env.type === 'ivydad') {
            document.removeEventListener('visibilitychange', this.visibilityChange);
        }
    }
};
Cart = tslib_1.__decorate([
    Component({
        components: {
            GoodsInfo,
            CartFooter,
            GiftsPop,
            DiscountPop,
            CartLevel,
            TitleBar,
        },
    })
], Cart);
export default Cart;
